import APIS from "../constant/EndPoint";
import useGetHook from "../customHooks/useUserServiceGetHook";

interface IAccessControlProps {
  allowedPermissions: any;
  children: any;
  renderNoAccess?: any;
}

const AccessControl = ({
  allowedPermissions,
  children,
  renderNoAccess,
}: IAccessControlProps) => {
  const { data } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });
  const permissionsLists: any = data && data?.groups?.map((item: any) => item.custom_permissions).flat();
  let isAllowed: boolean = permissionsLists?.some((permission: any) =>
    allowedPermissions.includes(permission) || allowedPermissions.includes("no-permission-required"),
  );
  if (isAllowed || data?.is_superuser) {
    return children;
  }

  return renderNoAccess ?? null;
};



export default AccessControl;